// extracted by mini-css-extract-plugin
export default {"container":"SelectionHalf_container__NI1E5","selected":"SelectionHalf_selected__M1N+K","option":"SelectionHalf_option__E60wo"};